import React, { useEffect, useRef, useState } from 'react';
import api from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';
import arrowIcon from '../../assets/images/Arrow.svg';
import "../../styles/dataTable.css";
import searchIcon from '../../assets/images/search_icon.svg';
import editIcon from '../../assets/images/edit_icon.svg';
import StateCityFilter from '../../components/stateCityFilter';
// import CreatePackageInPage from './CreatePackageInPage';
// import UpdatePackageInPage from './UpdatePackageInPage';
import addIcon from '../../assets/images/add-icon.svg'

const TotalUmrahPackages = () => {
  const navigate = useNavigate();
  const location = useLocation();
    const filterType = location.state?.filterType || "";
  const [cards, setCards] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [categories, setCategories] = useState([]);

  const [showCreatePackage, setShowCreatePackage] = useState(false);
  const [showUpdatePackage, setShowUpdatePackage] = useState(false);
  const containerRef = useRef(null);
  const containerUpdateRef = useRef(null);

  
    // ✅ FILTER STATE
    const [filters, setFilters] = useState({
      state: "",
      city: "",
      status: "",
      servicePlan: "",
    });

  // Table state
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredData = cards.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  // Sort Toggle Handler
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Fetch API data
  useEffect(() => {
    fetchVendor();
    fetchCategory();
    fetchCards();
  }, [showCreatePackage, showUpdatePackage]);

  const fetchVendor = async () => {
    try {
      const response = await api.get('/vendor/get-all');
      setVendors(response.data.data || []);
    } catch (error) {
      console.error('Error fetching Service Provider data:', error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await api.get('/page/get-all');
      setCategories(response.data.data || []);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchCards = async () => {
  try {
    const formData = new FormData();

    // ✅ SEND STATUS BASED ON CLICK
    if (filterType === "active") {
      formData.append("status", "1");
    } 
    else if (filterType === "inactive") {
      formData.append("status", "0");
    }
    else if (filterType === "expired") {
      formData.append("packagesatus", "expired");
    }

        // ✅ STATE
    if (filters.state) {
      formData.append("state", filters.state);   // 🔥 CHANGE HERE
    }

    // ✅ CITY
    if (filters.city) {
      formData.append("city", filters.city);     // 🔥 CHANGE HERE
    }


    // ✅ STATUS
    if (filters.status) {
      formData.append("status", filters.status);
    }

    // ✅ SERVICE PLAN
    if (filters.servicePlan) {
      formData.append("service_plan", filters.servicePlan);
    }




    const response = await api.post(
      '/dashboard/umrahpackgelist',
      formData
    );

    setCards(response.data.data || []);

  } catch (error) {
    console.error('Error fetching card data:', error);
  }
};

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cards/${id}`);
      setCards(cards.filter(card => card.id !== id));
      alert(`Package with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Error deleting package');
    }
  };

  const handleCreatePackageClick = () => {
    // navigate('/create-package');
    setShowCreatePackage(true)
  };

  // const handlePackageUpdate = (id) => {
  //   setShowUpdatePackage(true);
  // };

  return (
      <div style={{ padding: "20px" }}>
        {/* Table Header */}
                <h2 style={{ fontWeight: 700 , marginBottom: "20px" }}>Umrah Package</h2>
         <StateCityFilter onChange={setFilters} fetchCards={fetchCards} /> 

        <div className="table-header" style={{display: "flex",flexDirection:'column', justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "0px",flexwrap: "wrap",aligncontent: "stretch", padding: "5px 22px "}}>
            <div style={{display: "flex",  alignSelf: "flex-end",gap:"30px", marginTop: "10px", width: "100%"}}>

          

          <div className="entries-container">
            <label htmlFor="noOfEntries">Show: </label>
            <select
              value={entriesPerPage}
              id="noOfEntries"
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries per page</option>
              <option value={50}>50 Entries per page</option>
              <option value={100}>100 Entries per page</option>
            </select>
          </div>

          <div className="search-container">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="search"
            />
            <img src={searchIcon} alt="search-icon" className="search-icon" />
          </div>

          </div>

          {/* <div className="action-btn">
              <button onClick={handleCreatePackageClick}>
                <img src={addIcon} alt="add-icon" />  Add Package
              </button>
          </div> */}

        </div>

        {/* Table */}
        <table width="100%" cellPadding="15" className="table-no-outer-border">
          <thead>
            <tr>
              {/* <th onClick={() => handleSort("category_id")}>Pilgrimage Type</th> */}
              <th onClick={() => handleSort("packagename")}>Packagename</th>
              {/* <th onClick={() => handleSort("city")}>City</th> */}
              <th onClick={() => handleSort("duration")}>Duration</th>
              <th onClick={() => handleSort("price")}>Price</th>
              <th>Image</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((card, i) => (
                <tr key={card.id}>
                  {/* <td>{categories?.find(el => el.id === card.category_id)?.name || "N/A"}</td> */}
                  <td>{card.packagename}</td>
                  {/* <td>{card.city}</td> */}
                  <td>{card.duration}</td>
                  <td>₹ {parseFloat(card.price).toLocaleString('en-IN')}</td>
                  <td>
                    <img
                      style={{ width: '90px', borderRadius: '5px' }}
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${card.image_path}`}
                      alt="banner"
                    />
                  </td>
                  <td>{card?.is_approved !== '1' ? "Pending" : "Approved"}</td>
                  {/* <td className='text-center align-middle'>
                    <button className='edit-button' onClick={() => handlePackageUpdate(card.id)}>
                      <img src={editIcon} alt="editIcon" /> Edit
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>No data found</td>
              </tr>
            )}
          </tbody>
        </table>

   {/* Pagination */}
<div style={{ paddingBottom: '30px', background: '#fff' }}>
  <div
    style={{
      padding: "30px",
      textAlign: "center",
      borderTop: '2px solid #F2F2F2',
      borderBottom: '2px solid #F2F2F2'
    }}
  >
    {/* Prev button */}
    <button
      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      style={{
        margin: "0 5px",
        border: "none",
        background: "#fff",
        cursor: currentPage === 1 ? "not-allowed" : "pointer"
      }}
    >
      <img
        src={arrowIcon}
        alt="prev"
        style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
      />
    </button>

    {/* Page numbers */}
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        style={{
          margin: "0 5px",
          padding: "5px 10px",
          background: currentPage === page ? "#D9D9D9" : "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        {page}
      </button>
    ))}

    {/* Next button */}
    <button
      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      style={{
        margin: "0 5px",
        border: "none",
        background: "#fff",
        cursor: currentPage === totalPages ? "not-allowed" : "pointer"
      }}
    >
      <img
        src={arrowIcon}
        alt="next"
        style={{
          opacity: currentPage === totalPages ? 0.5 : 1,
          transform: "rotateY(180deg)"
        }}
      />
    </button>
  </div>
</div>

      </div>

  );
};

export default TotalUmrahPackages;
